var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLastRefresh = function SvgLastRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 12",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.5a4.05 4.05 0 00-7.75-1M2 2.5v2h2m-2 2a4.05 4.05 0 007.75 1m.25 2v-2H8",
    stroke: "#6E7D8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLastRefresh;